/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { AddressForm } from '@/components/blocks/AddressForm';
import { shippingTitleGeneralSX } from '@/components/content/CheckOut/parts/Shipping/custom/styles/typography';
import { checkoutTitleSX } from '@/components/content/CheckOut/styles/title';
import { useCheckOut } from '@/data/Content/CheckOut';
import { useShipping } from '@/data/Content/Shipping';
import { ContentContext } from '@/data/context/content';
import { Typography } from '@mui/material';
import { FC, useContext } from 'react';

interface ShippingCreateEditAddressProps {
	editPerson?: boolean;
	hasPrimaryAdd?: boolean;
}

export const ShippingCreateEditAddress: FC<ShippingCreateEditAddressProps> = ({
	editPerson,
	hasPrimaryAdd,
}) => {
	/**
	 * addressToEdit is the original address to edit
	 * editableAddress is the address fit into form without addressId
	 * if addressToEdit contains addressId means it is to update
	 */
	const {
		editableAddress,
		editablePersonalData,
		onAddressEditOrCreate,
		toggleEditCreateAddress,
		toggleEditPersonalData,
	} = useContext(ContentContext) as ReturnType<typeof useCheckOut> & ReturnType<typeof useShipping>;

	const addressInput = editableAddress || editablePersonalData;

	return addressInput ? (
		<AddressForm
			editPerson={editPerson}
			addressInput={addressInput}
			onSubmit={onAddressEditOrCreate}
			submitLabel="SaveAndSelect"
			formLabel={<Typography sx={checkoutTitleSX}>{'DATOS DE CONTACTO'}</Typography>}
			cancelLabel="Cancel"
			onCancel={editPerson ? toggleEditPersonalData(null) : toggleEditCreateAddress(null)}
			hasPrimaryAdd={hasPrimaryAdd}
		/>
	) : null;
};
